import Vue from 'vue';
import Vuex from 'vuex';

import search from './modules/search';
import dashboards from './modules/dashboards';
import organizations from './modules/organizations';
import medias from './modules/medias';
import users from './modules/users';
import journals from './modules/journals';
import journal_details from './modules/journal_details';
import clipping from "./modules/clipping";
import reports from "./modules/reports";
import clips from "./modules/clips";

import md5 from 'js-md5';
import axios from "axios";

Vue.use(Vuex);

let store = new Vuex.Store({
    modules: {
        search,
        dashboards,
        organizations,
        medias,
        users,
        journals,
        journal_details,
        clipping,
        reports,
        clips,
    },

    state: {
        unauthorized: false,
        unauthorizedMsg: '',

        requireReload: false,
    },

    mutations: {
        setUnauthorized(state, data) {
            state.unauthorized = data
        },

        setUnauthorizedMsg(state, data) {
            state.unauthorizedMsg = data;
        },

        setRequireReload(state, data) {
            state.requireReload = data;
        },
    },

    actions: {
        setUnauthorized({commit}, isUnauthorized) {
            commit('setUnauthorized', isUnauthorized)
        },

        handleResponse({ commit }, { status }) {
            commit('setUnauthorized', ( status === 403 ));
        },

        resetStates({ commit }) {
            commit('dashboards/resetState');
            commit('journal_details/resetState');
            commit('medias/resetState');
            commit('organizations/resetState');
            commit('search/resetState');
            commit('users/resetState');
            commit('reports/resetState');
            commit('clipping/resetState');
            commit('clips/resetState');
        },

        changeUserPassword(_, { oldPassword, newPassword }) {
            return axios.post(process.env.VUE_APP_API_URL + "users/change-password", {
                'old_password': md5(oldPassword),
                'new_password': md5(newPassword)
            });
        },
    },

    getters: {
        isUnauthorized(state) {
            return state.unauthorized
        },
    }
});

export default store;